import React from "react";
//Limitless imports
import { ManagerHeaderItem } from "@limitless/portal";
const TenantGroupSettings = () => {
  return /*#__PURE__*/React.createElement(ManagerHeaderItem, {
    label: "Display Non-Production Groups",
    description: "When enabled will show Non-Production Groups in the Tenant/Group selectors",
    profileKey: "showNonProdGroups"
  });
};
export default TenantGroupSettings;